import { render, staticRenderFns } from "./NotificationLogs.vue?vue&type=template&id=7d09b5a9&"
import script from "./NotificationLogs.vue?vue&type=script&lang=js&"
export * from "./NotificationLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports